import type { CommandFn, CommandName, CommandOpts, CommandResult } from "./types";

// CommandFn<CommandName> here loses per-name type narrowing — the casts at the
// `registerCommand` and `runCommand` boundaries restore it for callers.
const commands = new Map<CommandName, CommandFn<CommandName>>();

export const registerCommand = <N extends CommandName>(name: N, fn: CommandFn<N>): void => {
  if (commands.has(name)) {
    throw new Error(`Command already registered: ${name}`);
  }
  commands.set(name, fn as unknown as CommandFn<CommandName>);
};

export const runCommand = <N extends CommandName>(
  name: N,
  opts: CommandOpts<N>,
): CommandResult<N> => {
  const fn = commands.get(name) as CommandFn<N> | undefined;
  if (!fn) {
    throw new Error(`Command not registered: ${String(name)}`);
  }
  return fn(opts);
};
